import {
    HANDLE_DRAWER_TOGGLE_CHANGE
} from '../constants/Index';

const initialState = {
  toggleStatus : true
};

export default function appReducer(state = initialState, action) {
    switch (action.type) {
        case HANDLE_DRAWER_TOGGLE_CHANGE:
            return Object.assign({}, state, {
                toggleStatus: action.toggleStatus
            });
        default:
            return state
    }
}
